import { useEffect } from "react";
import { Link } from "wouter";

export default function Terms() {
  useEffect(() => {
    document.title = "Terms | Codevector Cloud";
  }, []);

  return (
    <main className="h-screen overflow-y-auto bg-background text-foreground">
      <div className="mx-auto max-w-3xl px-6 py-10 sm:py-14">
        <Link
          href="/"
          className="mb-8 inline-flex text-sm font-medium text-primary hover:underline"
        >
          Back to Codevector
        </Link>

        <article className="prose prose-invert max-w-none prose-headings:text-foreground prose-p:text-muted-foreground prose-li:text-muted-foreground prose-a:text-primary">
          <p className="text-sm font-medium uppercase tracking-wide text-primary">
            Codevector Cloud
          </p>
          <h1>Terms of Service</h1>

          <p>
            This app is a private/internal automation tool for owner-approved
            Threads publishing. It is intended to help draft, review, approve,
            and publish content that the owner explicitly authorizes.
          </p>

          <h2>Approved Publishing</h2>
          <p>
            Users are responsible for the content they approve and publish.
            Content should comply with applicable laws, platform policies, and
            Meta/Threads rules.
          </p>

          <h2>Service Availability</h2>
          <p>
            The app may change, pause, or stop operating at any time. No
            guarantee is made that automation, publishing, or integrations will
            always be available.
          </p>

          <h2>Contact</h2>
          <p>
            For questions about these terms, email{" "}
            <a href="mailto:lockogift@gmail.com">lockogift@gmail.com</a>.
          </p>
        </article>
      </div>
    </main>
  );
}
